<div [formGroup]="myGroup" class="toggle-html-element-container">
    <div class="toggle-wrapper">
        <mat-label class="toggle-label">
            <mat-icon class="label-icon" *ngIf="name === 'visible'">visibility</mat-icon>
            <mat-icon class="label-icon" *ngIf="name === 'required'">star</mat-icon>
            <span>{{name}}</span>
        </mat-label>
        <mat-slide-toggle
            name="customElement"
            formControlName="customElement"
            color="primary"
            (change)="OnChanged($event)"
        ></mat-slide-toggle>
    </div>
</div>